import type { ComponentProps } from "react";
import { cn } from "@/lib/utils";
import { Table } from "./ui/table";

/**
 * A table that runs edge to edge across the page, with the first and last cells padded
 * to the gutter so the text lines up with the header and toolbar above it. The heading
 * row is quiet. It is not sticky: the table scrolls sideways in its own container, which
 * would be what a sticky heading pinned to.
 */
export function FlatTable({ className, ...props }: ComponentProps<typeof Table>) {
  return (
    <div className="-mx-gutter">
      <Table
        className={cn(
          "[&_th]:h-9 [&_th]:text-xs [&_th]:font-medium [&_th]:text-muted-foreground",
          "[&_td]:py-2 [&_tbody_tr]:border-border/60 [&_tbody_tr]:transition-colors [&_tbody_tr]:duration-(--motion-dur)",
          "[&_td:first-child]:pl-gutter [&_th:first-child]:pl-gutter [&_td:last-child]:pr-gutter [&_th:last-child]:pr-gutter",
          className,
        )}
        {...props}
      />
    </div>
  );
}
